export default {
  roundOnly: true,
  checkoutFormVariant: 'd',
  planSet: 'pricing-35',
  growthbookFeatures: ['supp', 'thankyou_tips'],
  sexologyUpsellEnabled: false,
};
